import {
  ADVANCE_SEARCH_DATA_REQUEST,
  ADVANCE_SEARCH_DATA_SUCCESS,
  ADVANCE_SEARCH_DATA_LOADING,
  ADVANCE_SEARCH_DATA_FAILURE,
} from '../actionTypes';

export const fetchASDOptions = (payload : any) => ({
    type: ADVANCE_SEARCH_DATA_REQUEST,
    payload
});

export const fetchASDOptionsSuccess = (payload : any) => ({
    type: ADVANCE_SEARCH_DATA_SUCCESS,
    payload
});

export const fetchASDOptionsLoading = (payload : any) => ({
    type: ADVANCE_SEARCH_DATA_LOADING,
    payload
});
//action for ASDO

export const fetchASDOptionsError = (payload : any) => ({
    type: ADVANCE_SEARCH_DATA_FAILURE,
    payload
});
